/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import textClassification_IconURL from './menu.png';
import textClassification_InsetIconURL from './icon.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Text Classification"
        description="name for the Text Classification extension"
        id="extension.textClassification.name"
    />
  ),
	tags: ["Made by PRG"],
	insetIconURL: textClassification_InsetIconURL,
	iconURL: textClassification_IconURL,
	description: 
  (
    <FormattedMessage
        defaultMessage="Create a text classification model for use in a Scratch project!"
        description="description for the Text Classification extension"
        id="extension.textClassification.description"
    />
  ),
	featured: true,
	extensionId: 'textClassification',
}